export default "/assets/images/current-room-status.mp4?4338beb709d6b542fc4717ff07e3c68b";